$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top -150
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });

  // Buy it now button

  $('.menu-buy-now').parent().parent().on('click', function(e){

    e.preventDefault();

    $('.slideshow:first-child').find('.btn').click();
  });

  // check URL parameter on product page and jump to Buy now section

  var urlParams = new URLSearchParams(window.location.search); //get all parameters
  var foo = urlParams.get('variant'); //extract the foo parameter - this will return NULL if foo isn't a parameter

  if(foo) { //check if foo parameter is set to anything
      if(foo > 0){
        $('.slideshow:first-child').find('.btn').click();
      }
  }

  // swiper
  //swiper-slide-next
  $('.swiper-arrow-added-right').click(function(e){
    e.preventDefault();
    $('.swiper-pagination-bullet-active').next().click();
  });
  $('.swiper-arrow-added-left').click(function(e){
    e.preventDefault();
    $('.swiper-pagination-bullet-active').prev().click();
  });


  // Image to Variant selector
  $('.product-thumbnails__item-link').click(function(){
    var idx = $(this).parent().index();

    var swatches = $('.product__color-swatch');
    if(swatches.length > 0){
      swatches[idx]?.click();

      if(swatches[idx]){
        var txt = $(swatches[idx]).attr('data-option-value');
        swatchLabel(txt);
      }
      else{
        swatchLabel(null);
      }
    }
  });

  $('.product__color-swatch').click(function(){
    swatchLabel($(this).attr('data-option-value'));
  });

  function swatchLabel(txt){

    var prep = "<strong>Model:</strong> ";

    if(txt == null){
      $('.swatch-label').html("&nbsp;");
      return;
    }

    var lbl = $('.swatch-label');
    lbl.html(prep + txt);
  }

  function swatchLabel(txt){

    var prep = "<strong>Model:</strong> ";

    if(txt == null){
      $('.swatch-label').html("&nbsp;");
      return;
    }

    var lbl = $('.swatch-label');
    lbl.html(prep + txt);
  }


  // function cart_buttons() { 
  //   console.log('cart buttons');

  //   const container = document.querySelector('.accelerated-checkout-button');
  //   container.style.borderRadius = '18px';
  //   container.style.overflow = 'hidden';
  // } 

  // setTimeout( function() {
  //   cart_buttons();
  // }, 4000);






    // end
});


// Detect Country and append CAD to prices if in Canada
$(document).ready(function(){


  return;
  
  if (!$('body').hasClass('template-product') &&
      !$('body').hasClass('template-collection')) {
    return;
  }

  fetch('/browsing_context_suggestions.json')
    .then(res => res.json())
    .then(data => {

      const country =
        data?.detected_values?.country?.handle || null;

      console.log('Detected Country:', country);

      if (country !== "CA") return;

      $('.product-item__price, span[data-price]').each(function(){

        let text = $(this).text().trim();

        // Remove any existing CAD first
        text = text.replace(/\s?CAD/g, '');

        $(this).text(text + ' CAD');

      });

    });

});
